import { RFWebPermissaoEnum } from 'app/shared/auth/permissao/cadastro-menu-routes-permission.config';
import { RouteInfo } from 'app/shared/vertical-menu/vertical-menu.metadata';

export const CADASTRO_USUARIO_PLAYER_MENU_ROUTES: RouteInfo[] = [
  {
    path: '', title: 'Player', icon: 'fa fa-play', id: 23, willHaveSub: true,
    authGuardKey: RFWebPermissaoEnum.rfpCadastroUsuarioPlayer,
    class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, submenu: [
      {
        path: '/cadastro-player/player/contato', title: 'Contato', icon: 'fa fa-address-card', id: 24,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroUsuarioPlayerContato
      },
      {
        path: '/cadastro-player/player/coletanea', title: 'Coletânea', icon: 'fa fa-object-group', id: 25,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroUsuarioPlayerColetanea
      },
      {
        path: '/cadastro-player/player/musicas', title: 'Músicas', icon: 'fa fa-music', id: 26,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroUsuarioPlayerMusicas
      },
      {
        path: '/cadastro-player/player/atividades', title: 'Atividades', icon: 'fa fa-list-ul', id: 27,
        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],
        authGuardKey: RFWebPermissaoEnum.rfpCadastroUsuarioPlayerAtividades
      },
    ],
  },
]
